'use client'

import Head from 'next/head'
import Msw, { IBook } from '@/components/main/Msw'
import Script from 'next/script'
import { useEffect, useState } from 'react'
import generateNonce from '@/utils/generateNonce'
import getErrorMessage from '@/utils/getErrorMessage'

const MswPage = () => {
  const initialBook: IBook = {
    status: 'SERVER',
    title: 'Lord of the Rings',
    imageUrl: 'https://images.unsplash.com/photo-1618845072579-853968656c0e',
    description:
      'The Lord of the Rings is an epic high-fantasy novel written by English author and scholar J. R. R. Tolkien.',
  }

  const nonce = generateNonce()
  const [book, setBook] = useState(initialBook)

  // @@TODO: Migrate towards TanStack Query.
  useEffect(() => {
    async function fetchBook() {
      console.log('MswPage: fetchBook() called')
      let url
      if (process.env.NEXT_PUBLIC_API_MOCKING === 'enabled') {
        // @@TODO: This code (often) already runs before MSW is properly initialized.
        // @@TODO: Implement deferred loading. This is currently implemented with a delay.
        // NOTE: Because registering the Service Worker is an asynchronous operation, it’s a good idea to defer the rendering of your application until the registration Promise resolves.
        // https://mswjs.io/docs/integrations/browser#conditionally-enable-mocking
        url = 'https://mocked-server'
      } else {
        // Use absolute URLs only for unit tests: Vitest.
        url =
          process.env.NODE_ENV === 'test'
            ? (process.env.NEXT_PUBLIC_BASE_URL as string)
            : ''
      }
      let book
      try {
        const res = await fetch(`${url}/api/msw/books`)
        book = (await res.json()) as IBook
      } catch (error) {
        // @@TODO
        throw new Error(getErrorMessage(error))
      }
      if (book) {
        setBook(book)
      }
    }
    const timerId = setTimeout(() => {
      // NOTE: Intentionally not awaited.
      void fetchBook()
    }, 1000)

    return () => clearTimeout(timerId) // cleanup timeout on unmount
  }, [])

  return (
    <>
      <Script id="page-listener" nonce={nonce}>
        console.log(`msw.tsx page script`)
      </Script>
      <Head>
        <title>MSW</title>
        <meta name="description" content="MSW" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <h1 className="text-2xl font-bold">MSW</h1>
      <Msw book={book} nonce={nonce} />
    </>
  )
}

export default MswPage
